(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-cart-content"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (window.MembracleanContinueShopping) return;

  const linkSelector = '[data-mc-continue-shopping]';
  const root = new URL(document.querySelector('[data-mc-shop-root]')?.dataset.mcShopRoot || window.Shopify?.routes?.root || '/', location.origin).pathname.replace(/\/?$/, '/');
  const storageKey = 'mc:continue-shopping:v1:' + root;
  const maxAge = 24 * 60 * 60 * 1000;

  const shoppingURL = (value) => {
    if (typeof value !== 'string' || !value.trim() || value.length > 4096) return '';
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || url.username || url.password) return '';
      if (!url.pathname.startsWith(root)) return '';
      const path = url.pathname.slice(root.length).replace(/\/$/, '');
      if (path && !/^(products|collections|pages|blogs)(\/|$)/.test(path) && path !== 'search') return '';
      if (/\.(js|json|xml)$/i.test(path) || url.searchParams.has('section_id') || url.searchParams.has('sections')) return '';
      return url.pathname + url.search + url.hash;
    } catch {
      return '';
    }
  };

  const readPrevious = () => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      const age = Date.now() - saved?.time;
      if (Number.isFinite(age) && age >= 0 && age <= maxAge) return shoppingURL(saved?.url);
    } catch {}
    return '';
  };

  const rememberPage = () => {
    if (document.body?.classList.contains('template-404')) return;
    const url = shoppingURL(location.href);
    if (!url) return;
    try { sessionStorage.setItem(storageKey, JSON.stringify({ url, time: Date.now() })); } catch {}
  };

  const updateLinks = () => {
    const destination = readPrevious() || shoppingURL(document.referrer);
    document.querySelectorAll(linkSelector).forEach((link) => {
      if (!link.dataset.mcContinueFallback) link.dataset.mcContinueFallback = link.getAttribute('href');
      link.setAttribute('href', destination || link.dataset.mcContinueFallback);
    });
  };

  const initialize = () => {
    rememberPage();
    updateLinks();
  };

  document.addEventListener('cart:updated', updateLinks);
  document.addEventListener('shopify:section:load', updateLinks);
  document.addEventListener('click', rememberPage, true);
  document.addEventListener('submit', rememberPage, true);
  window.addEventListener('pagehide', rememberPage);
  window.addEventListener('pageshow', initialize);
  window.addEventListener('popstate', initialize);
  window.addEventListener('hashchange', rememberPage);
  window.MembracleanContinueShopping = { refresh: updateLinks };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-contact-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('McContactDialog');
  if (!dialog) return;

  const currentLocale = window.location.pathname.match(/^\/(nl|fr|da|it)(?:\/|$)/)?.[1] || 'de';
  const contactPages = {
    de: '/pages/kontaktieren-sie-uns',
    nl: '/nl/pages/contact-klantenservice',
    fr: '/fr/pages/contact-service-clients',
    da: '/da/pages/kontaktieren-sie-uns',
    it: '/it/pages/kontaktieren-sie-uns'
  };
  const contactPath = contactPages[currentLocale];

  // Request the six-digit challenge without requiring any user interaction.
  function ensureChallenge(form) {
    if (!form) return;
    const button = form.querySelector('[data-mc-human-refresh]');
    const image = form.querySelector('[data-mc-human-image]');
    if (!button || button.disabled || !image) return;
    const requested = Number(image.dataset.mcRequestedAt || 0);
    const expired = requested > 0 && Date.now() - requested > 180000;
    const failed = image.hasAttribute('src') && image.complete && image.naturalWidth === 0;
    if (!image.hasAttribute('src') || expired || failed) {
      image.dataset.mcRequestedAt = String(Date.now());
      button.click();
    }
  }

  function initializeChallenges() {
    document.querySelectorAll('[data-mc-contact-form]').forEach((form) => {
      if (!form.closest('dialog')) ensureChallenge(form);
    });
  }
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', () => window.setTimeout(initializeChallenges, 0), { once: true });
    window.addEventListener('load', initializeChallenges, { once: true });
  } else {
    window.setTimeout(initializeChallenges, 0);
  }

  function isContactLink(link) {
    if (!link || link.dataset.mcContactPage === 'true') return false;
    if (link.hasAttribute('data-mc-contact-open')) return true;

    try {
      const url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin
        && url.pathname.replace(/\/$/, '') === contactPath;
    } catch {
      return false;
    }
  }

  function openDialog() {
    if (typeof dialog.showModal !== 'function') {
      window.location.href = contactPath;
      return;
    }

    if (!dialog.open) dialog.showModal();
    ensureChallenge(dialog.querySelector('[data-mc-contact-form]'));

    const firstField = dialog.querySelector('input:not([type="hidden"]), select, textarea');
    if (firstField) window.setTimeout(() => firstField.focus(), 30);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link || !isContactLink(link)) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    openDialog();
  });

  dialog.querySelectorAll('[data-mc-contact-close]').forEach((button) => {
    button.addEventListener('click', () => dialog.close());
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('mc-contact:success', () => {
    const closeButton = dialog.querySelector('[data-mc-contact-close]');
    if (closeButton) closeButton.focus();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
  const states = new WeakMap();

  const contactText = {
    de: {
      configuration: 'Das Kontaktformular ist nicht vollständig konfiguriert.',
      codeLoad: 'Die Sicherheitsprüfung konnte nicht geladen werden. Bitte versuche es erneut.',
      sending: 'Wird gesendet …', success: 'Danke! Deine Nachricht wurde übermittelt.',
      sendError: 'Deine Nachricht konnte nicht gesendet werden. Bitte versuche es erneut.',
      codeError: 'Der Sicherheitscode ist ungültig oder abgelaufen. Bitte gib den neuen Code ein.',
      rateLimit: 'Zu viele Anfragen. Bitte versuche es später erneut.',
      connectionError: 'Die Verbindung wurde unterbrochen. Bitte versuche es erneut.',
      field: 'Bitte prüfe dieses Feld.',
      fields: { name: 'Bitte gib deinen Namen ein.', email: 'Bitte gib eine gültige E-Mail-Adresse ein.', message: 'Bitte schreibe eine Nachricht mit 10 bis 4000 Zeichen.', human_code: 'Bitte gib den sechsstelligen Sicherheitscode korrekt ein.' }
    },
    nl: {
      configuration: 'Het contactformulier is niet volledig ingesteld.',
      codeLoad: 'De beveiligingscontrole kon niet worden geladen. Probeer het opnieuw.',
      sending: 'Wordt verzonden…', success: 'Bedankt! Je bericht is verzonden.',
      sendError: 'Je bericht kon niet worden verstuurd. Probeer het opnieuw.',
      codeError: 'De beveiligingscode is ongeldig of verlopen. Vul de nieuwe code in.',
      rateLimit: 'Te veel aanvragen. Probeer het later opnieuw.',
      connectionError: 'De verbinding is verbroken. Probeer het opnieuw.',
      field: 'Controleer dit veld.',
      fields: { name: 'Vul je naam in.', email: 'Vul een geldig e-mailadres in.', message: 'Schrijf een bericht van 10 tot 4000 tekens.', human_code: 'Vul de juiste zescijferige beveiligingscode in.' }
    },
    fr: {
      configuration: 'Le formulaire de contact n’est pas correctement configuré.',
      codeLoad: 'Le contrôle de sécurité n’a pas pu être chargé. Réessaie.',
      sending: 'Envoi en cours…', success: 'Merci ! Ton message a bien été envoyé.',
      sendError: 'Ton message n’a pas pu être envoyé. Réessaie.',
      codeError: 'Le code de sécurité est incorrect ou a expiré. Saisis le nouveau code.',
      rateLimit: 'Trop de demandes. Réessaie plus tard.',
      connectionError: 'La connexion a été interrompue. Réessaie.',
      field: 'Vérifie ce champ.',
      fields: { name: 'Saisis ton nom.', email: 'Saisis une adresse e-mail valide.', message: 'Rédige un message de 10 à 4 000 caractères.', human_code: 'Saisis correctement le code de sécurité à six chiffres.' }
    },
    da: {
      configuration: 'Kontaktformularen er ikke korrekt konfigureret.',
      codeLoad: 'Sikkerhedskoden kunne ikke indlæses. Prøv igen.',
      sending: 'Sender …', success: 'Tak! Din besked er blevet sendt.',
      sendError: 'Din besked kunne ikke sendes. Prøv igen.',
      codeError: 'Sikkerhedskoden er forkert eller udløbet. Indtast den nye kode.',
      rateLimit: 'For mange forespørgsler. Prøv igen senere.',
      connectionError: 'Forbindelsen blev afbrudt. Prøv igen.',
      field: 'Kontrollér dette felt.',
      fields: { name: 'Indtast dit navn.', email: 'Indtast en gyldig e-mailadresse.', message: 'Skriv en besked på mellem 10 og 4.000 tegn.', human_code: 'Indtast den korrekte sekscifrede sikkerhedskode.' }
    },
    it: {
      configuration: 'Il modulo di contatto non è configurato correttamente.',
      codeLoad: 'Impossibile caricare il codice di sicurezza. Riprova.',
      sending: 'Invio in corso…', success: 'Grazie! Il tuo messaggio è stato inviato.',
      sendError: 'Impossibile inviare il messaggio. Riprova.',
      codeError: 'Il codice di sicurezza è errato o scaduto. Inserisci il nuovo codice.',
      rateLimit: 'Troppe richieste. Riprova più tardi.',
      connectionError: 'La connessione è stata interrotta. Riprova.',
      field: 'Controlla questo campo.',
      fields: { name: 'Inserisci il tuo nome.', email: 'Inserisci un indirizzo e-mail valido.', message: 'Scrivi un messaggio da 10 a 4.000 caratteri.', human_code: 'Inserisci correttamente il codice di sicurezza a sei cifre.' }
    }
  };

  function getContactText(form) {
    return contactText[form.dataset.mcLocale] || contactText.de;
  }

  function getState(form) {
    if (!states.has(form)) {
      states.set(form, { token: '', pending: null });
    }
    return states.get(form);
  }

  function clearErrors(form) {
    form.querySelectorAll('[aria-invalid="true"]').forEach((field) => field.removeAttribute('aria-invalid'));
    form.querySelectorAll('[data-mc-error]').forEach((error) => {
      error.textContent = '';
    });
  }

  function setImage(form, token) {
    const endpoint = form.dataset.endpoint;
    const image = form.querySelector('[data-mc-human-image]');
    const loading = form.querySelector('[data-mc-human-loading]');
    if (!image || !endpoint) return;

    image.onload = () => {
      image.hidden = false;
      if (loading) loading.hidden = true;
      const status = form.querySelector('[data-mc-contact-status]');
      if (status && !status.classList.contains('is-success')) status.textContent = '';
    };

    image.onerror = () => {
      image.hidden = true;
      getState(form).token = '';
      if (loading) {
        loading.hidden = false;
        const locale = form.dataset.mcLocale;
        loading.textContent = locale === 'it'
          ? 'Impossibile caricare il codice di sicurezza. Mostra un nuovo codice.'
          : locale === 'nl'
          ? 'De beveiligingscode kon niet worden geladen. Toon een nieuwe code.'
          : locale === 'fr'
          ? 'Le code de sécurité ne peut pas être chargé. Affiche un nouveau code.'
          : locale === 'da'
          ? 'Sikkerhedskoden kunne ikke indlæses. Vis en ny kode.'
          : 'Der Sicherheitscode konnte nicht geladen werden. Bitte neuen Code anzeigen.';
      }
    };

    image.src = endpoint + '?human_code_image=1&token=' + encodeURIComponent(token) + '&_=' + Date.now();
  }

  async function prepare(form, force = false) {
    const state = getState(form);
    const endpoint = form.dataset.endpoint;

    if (!endpoint) throw new Error(getContactText(form).configuration);
    if (state.token && !force) return state.token;
    if (state.pending && !force) return state.pending;

    state.token = '';
    state.pending = fetch(endpoint, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    })
      .then(async (response) => {
        const result = await response.json();
        if (!response.ok || !result.token) {
          throw new Error(getContactText(form).codeLoad);
        }
        state.token = result.token;
        setImage(form, state.token);
        return state.token;
      })
      .catch((error) => {
        const loading = form.querySelector('[data-mc-human-loading]');
        if (loading) {
          loading.hidden = false;
          const locale = form.dataset.mcLocale;
          loading.textContent = locale === 'it'
            ? 'Impossibile caricare il codice di sicurezza. Riprova con un nuovo codice.'
            : locale === 'nl'
            ? 'De beveiligingscode kon niet worden geladen. Probeer het opnieuw.'
            : locale === 'fr'
            ? 'Impossible de charger le code de sécurité. Réessaie.'
            : locale === 'da'
            ? 'Sikkerhedskoden kunne ikke indlæses. Prøv igen.'
            : 'Der Sicherheitscode konnte nicht geladen werden. Bitte erneut versuchen.';
        }
        throw error;
      })
      .finally(() => {
        state.pending = null;
      });

    return state.pending;
  }

  async function refreshChallenge(form) {
    const state = getState(form);
    state.token = '';

    const image = form.querySelector('[data-mc-human-image]');
    const loading = form.querySelector('[data-mc-human-loading]');
    const input = form.querySelector('[data-mc-human-input]');

    if (image) image.hidden = true;
    if (loading) loading.hidden = false;
    if (input) {
      input.value = '';
      input.removeAttribute('aria-invalid');
    }

    const error = form.querySelector('[data-mc-error="human_code"]');
    if (error) error.textContent = '';

    return prepare(form, true);
  }

  document.querySelectorAll('[data-mc-contact-form]').forEach((form) => {
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-mc-contact-status]');
    const humanInput = form.querySelector('[data-mc-human-input]');
    const refreshButton = form.querySelector('[data-mc-human-refresh]');

    form.addEventListener('focusin', () => {
      prepare(form).catch((error) => {
        if (status) status.textContent = getContactText(form).codeLoad;
      });
    }, { once: true });

    if (humanInput) {
      humanInput.addEventListener('input', () => {
        humanInput.value = humanInput.value.replace(/\D/g, '').slice(0, 6);
        humanInput.setCustomValidity('');
      });
    }

    if (refreshButton) {
      refreshButton.addEventListener('click', () => {
        refreshButton.disabled = true;
        refreshChallenge(form)
          .catch((error) => {
            if (status) status.textContent = getContactText(form).codeLoad;
          })
          .finally(() => {
            refreshButton.disabled = false;
          });
      });
    }

    form.addEventListener('input', (event) => {
      const field = event.target;
      if (!field || !field.name || !field.validity || !field.validity.valid) return;
      field.removeAttribute('aria-invalid');
      const error = form.querySelector('[data-mc-error="' + field.name + '"]');
      if (error) error.textContent = '';
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!button || button.disabled) return;

      const copy = getContactText(form);
      clearErrors(form);
      if (status) {
        status.textContent = '';
        status.classList.remove('is-success');
      }

      const invalidFields = Array.from(form.elements)
        .filter((field) => field.willValidate && !field.checkValidity());
      if (invalidFields.length) {
        invalidFields.forEach((field) => {
          const error = form.querySelector('[data-mc-error="' + field.name + '"]');
          field.setAttribute('aria-invalid', 'true');
          if (error) error.textContent = copy.fields[field.name] || copy.field;
        });
        invalidFields[0].focus();
        return;
      }

      const idleLabel = button.dataset.idleLabel || button.textContent;
      button.disabled = true;
      button.textContent = copy.sending;

      try {
        const token = await prepare(form);
        const data = new FormData(form);
        data.set('token', token);

        const response = await fetch(form.dataset.endpoint, {
          method: 'POST',
          mode: 'cors',
          body: data,
          headers: { Accept: 'application/json' }
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          Object.entries(result.fields || {}).forEach(([key, message]) => {
            const field = form.elements.namedItem(key);
            const error = form.querySelector('[data-mc-error="' + key + '"]');
            if (field && field.setAttribute) field.setAttribute('aria-invalid', 'true');
            if (error) error.textContent = copy.fields[key] || copy.field;
          });

          if (result.refresh_challenge) {
            await refreshChallenge(form);
          }

          throw new Error(response.status === 429 ? copy.rateLimit : (result.refresh_challenge ? copy.codeError : copy.sendError));
        }

        form.reset();
        getState(form).token = '';
        const image = form.querySelector('[data-mc-human-image]');
        const loading = form.querySelector('[data-mc-human-loading]');
        if (image) image.hidden = true;
        if (loading) loading.hidden = false;

        if (status) {
          status.classList.add('is-success');
          status.textContent = copy.success;
          status.focus();
        }

        form.dispatchEvent(new CustomEvent('mc-contact:success', { bubbles: true }));
      } catch (error) {
        if (status) {
          const expected = [copy.configuration, copy.codeLoad, copy.codeError, copy.rateLimit, copy.sendError];
          status.textContent = error instanceof Error && expected.includes(error.message)
            ? error.message
            : copy.connectionError;
          status.focus();
        }
      } finally {
        button.disabled = false;
        button.textContent = idleLabel;
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-social-sharing"] && !Shopify.designMode) return;
  try {
    (() => {
    const copyButtons = document.querySelectorAll('[data-mc-share-copy]');
    copyButtons.forEach((button) => {
      if (button.dataset.mcShareReady === 'true') return;
      button.dataset.mcShareReady = 'true';

      button.addEventListener('click', async () => {
        const url = button.dataset.shareUrl || window.location.href;
        const label = button.querySelector('[data-mc-share-copy-label]');
        const original = label ? label.textContent : '';

        try {
          await navigator.clipboard.writeText(url);
          if (label) label.textContent = button.dataset.mcShareCopied || 'Link kopiert';
        } catch (error) {
          const helper = document.createElement('textarea');
          helper.value = url;
          helper.setAttribute('readonly', '');
          helper.style.position = 'fixed';
          helper.style.opacity = '0';
          document.body.appendChild(helper);
          helper.select();
          document.execCommand('copy');
          helper.remove();
          if (label) label.textContent = button.dataset.mcShareCopied || 'Link kopiert';
        }

        window.setTimeout(() => {
          if (label) label.textContent = original;
        }, 2200);
      });
    });

    const nativeItems = document.querySelectorAll('[data-mc-share-native-item]');
    const nativeButtons = document.querySelectorAll('[data-mc-share-native]');

    if (typeof navigator.share === 'function') {
      nativeItems.forEach((item) => {
        item.hidden = false;
      });

      nativeButtons.forEach((button) => {
        if (button.dataset.mcShareReady === 'true') return;
        button.dataset.mcShareReady = 'true';

        button.addEventListener('click', async () => {
          try {
            await navigator.share({
              title: button.dataset.shareTitle || document.title,
              url: button.dataset.shareUrl || window.location.href
            });
          } catch (error) {}
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
